import React from "react";
import Lottie from "lottie-react";
import BgNet from "@/assets/images/bg-net.svg";
import congratsAnimation from "@/assets/lottie/congrats.json";
import congratsImage from "@/assets/images/congrats.svg";
import Div100vh from "react-div-100vh";

export default function SuccessScreen() {
  return (
    <div className="w-full h-screen flex flex-col justify-between py-8 px-8 items-center bg-gradient-to-b from-[#1B1B1B] to-[#0153ab]">
      <img className="absolute" src={BgNet} />
      <div className="w-full flex flex-col gap-3 items-start mt-[20%]">
        <h1 className="text-4xl text-white font-medium leading-snug">
          Welcome To
          <br />
          <span className="font-semibold">
            Circle<span className="text-[#419dff]">Pe</span> Club
          </span>
        </h1>
        <h3 className="text-[#ddd] font-normal text-xl">
          {" "}
          You are a credit{" "}
          <span className="font-semibold text-white"> worthy </span> tenant!
        </h3>
      </div>
      <div className="w-full ">
        <div className="relative">
          <Lottie
            animationData={congratsAnimation}
            loop={true}
            className="relative z-20 w-full"
          />
          <img
            className="absolute inset-0 w-full h-fit justify-center items-center"
            src={congratsImage}
          />
        </div>
      </div>
      <div className="pb-4">
        <button className="rounded-full py-5 px-8 w-[300px] bg-[#EAFF00] font-semibold">
          Done
        </button>
      </div>
    </div>
  );
}
